/**
 * dualscreen plugin event types.
 */
export const DualscreenEvents = {
  /**
   * Fired when dual-screen mode chances.
   */
  CHANGE_LAYOUT: 'dualscreen_change_layout',
  SIDE_DISPLAYED: 'dualscreen_side_displayed'
};
